// src/beta/components/StoryChapterList.tsx
import { useNavigate } from 'react-router-dom';
import type { V1StorySummary } from '@/beta/types/dossier';

interface Props {
  vehicleId: string;
  stories: V1StorySummary[];
}

/** § 6.4 (7): Story chapter list — grid of cards.
 *  Tap navigates to /beta/showcase/[vehicleId]/stories/[storyId] (Phase G). */
export function StoryChapterList({ vehicleId, stories }: Props) {
  const navigate = useNavigate();

  if (stories.length === 0) {
    return (
      <p style={{ color: 'var(--vm-stone)', fontSize: 13, fontFamily: 'var(--vm-font-body)' }}>
        No stories on file.
      </p>
    );
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 'var(--vm-s-3)',
      }}
    >
      {stories.map((s) => (
        <button
          key={s.id}
          type="button"
          aria-label={s.title}
          onClick={() => navigate(`/beta/showcase/${vehicleId}/stories/${s.id}`)}
          style={{
            textAlign: 'left',
            background: 'var(--vm-dark-card)',
            border: '1px solid var(--vm-border)',
            padding: 0,
            cursor: 'pointer',
            color: 'var(--vm-warm-white)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              aspectRatio: '16 / 9',
              background: '#000',
              overflow: 'hidden',
            }}
          >
            {s.cover_url ? (
              <img
                src={s.cover_url}
                alt=""
                loading="lazy"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : null}
          </div>
          <div style={{ padding: 'var(--vm-s-2)' }}>
            <div
              style={{
                fontFamily: 'var(--vm-font-heading)',
                fontSize: 18,
                color: 'var(--vm-warm-white)',
              }}
            >
              {s.title}
            </div>
            <div
              style={{
                marginTop: 4,
                fontFamily: 'var(--vm-font-heading)',
                fontSize: 10,
                letterSpacing: '0.3em',
                textTransform: 'uppercase',
                color: 'var(--vm-stone)',
              }}
            >
              {s.slide_count} chapters
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
